import { ActionTypes as actions } from '../actions';

const initialState = {
  userProfileEdit: false,
  searchPracticeCode: false,
  createNewPractice: false,
  createEditLocation: false,
  addEditFrontDesk: false,
  saveBank: false,
  setBankCompanyName: false,
  resolveConsultation: false,
  changePassword: false,
  saveAppointment: false,
}

export default function LoadingReducer(state=initialState, action) {

  switch(action.type) {
    case actions.LOADING_CHANGE_PASSWORD:
      state = { ...state, changePassword: action.payload };
      break;
    case actions.LOADING_RESOLVE_CONSULTATION:
      state = { ...state, resolveConsultation: action.payload };
      break;
    case actions.LOADING_SAVE_BANK:
      state = { ...state, saveBank: action.payload };
      break;
    case actions.LOADING_SET_BANK_COMPANY:
      state = { ...state, setBankCompanyName: action.payload };
      break;
    case actions.LOADING_ADD_EDIT_FRONT_DESK:
      state = { ...state, addEditFrontDesk: action.payload };
      break;
    case actions.LOADING_ADD_EDIT_LOCATION:
      state = { ...state, createEditLocation: action.payload };
      break;
    case actions.LOADING_USER_PROFILE_EDIT:
      state = { ...state, userProfileEdit: action.payload };
      break;
    case actions.LOADING_SEARCH_PRACTICE_CODE:
      state = { ...state, searchPracticeCode: action.payload };
      break;
    case actions.LOADING_CREATE_NEW_PRACTICE:
      state = { ...state, createNewPractice: action.payload };
      break;
    case actions.LOADING_SAVE_APPOINTMENT:
      state = { ...state, saveAppointment: action.payload };
      break;
    case actions.USER_SIGN_OUT:
      state = initialState;
      break;
    default:

  }

  return state;
}
